export interface RepositoryType {
  name: string;
  description: string;
  stars: number;
  open_prs: number;
  open_issues: number;
  forks: number;
  colour: string;
  icon: string;
}

const fetchRepositories = async (): Promise<RepositoryType[]> => {
  const response = await fetch(`${process.env.PUBLIC_URL}/repositories`);
  if (!response.ok) {
    throw new Error("Failed to fetch repositories");
  }

  const text = await response.text();
  const lines = text.split("\n").filter((line) => line.trim() !== "");

  const repositories: RepositoryType[] = lines.map((line) => JSON.parse(line));
  return repositories;
  //const data = await response.json();
  //return data;
};

const staticRepositoriesDB: RepositoryType[] = [
  {
    name: "vuejs/core",
    stars: 1,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description:
      "🖖 Vue.js is a progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "facebook/react",
    stars: 2,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description: "The library for web and native user interfaces.",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "tensorflow/tensorflow",
    stars: 3,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description: "An Open Source Machine Learning Framework for Everyone",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "flutter/flutter",
    stars: 4,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description:
      "Flutter makes it easy and fast to build beautiful apps for mobile and beyond",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "git/git",
    stars: 5,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description:
      "Git Source Code Mirror - This is a publish-only repository but pull requests can be turned into patches to the mailing list via GitGitGadget",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "curl/curl",
    stars: 6,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description:
      "A command line tool and library for transferring data with URL syntax, supporting DICT, FILE, FTP, FTPS, GOPHER, GOPHERS, HTTP, HTTPS, IMAP, IMAPS, LDAP, LDAPS, MQTT, POP3, POP3S, RTMP, RTMPS, RTSP, SCP, SFTP, SMB, SMBS, SMTP, SMTPS, TELNET, TFTP, WS and WSS. libcurl offers a myriad of powerful features",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "torvalds/linux",
    stars: 7,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description: "Linux kernel source tree",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "microsoft/vscode",
    stars: 8,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description: "Visual Studio Code",
    colour: "#CB3837",
    icon: "python.svg",
  },
  {
    name: "github/gitignore",
    stars: 9,
    open_prs: 2,
    open_issues: 3,
    forks: 3,
    description: "A collection of useful .gitignore templates",
    colour: "#CB3837",
    icon: "python.svg",
  },
];

export { staticRepositoriesDB, fetchRepositories };
